import * as Sentry from '@sentry/react'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { ConfigProvider } from '@/providers/config'
import Router from '@/routes/Router'
import { ToastProvider } from '@/ui-components/ToastProvider'

import './index.css'

Sentry.init({
  dsn: 'https://fe4de24a22648103d31976e2112b482c@o4506936725536768.ingest.us.sentry.io/4509902395932672',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    'localhost',
    /^https:\/\/pay.ankor.io\/api/,
    /^https:\/\/pay.ankor.dev\/api/,
    /^https:\/\/[a-zA-Z0-9-]+\.ankor\.dev\/api/,
  ],
  // Session Replay
  replaysSessionSampleRate: 0.01,
  replaysOnErrorSampleRate: 1.0,
  // Enable logs to be sent to Sentry
  enableLogs: true,
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ConfigProvider>
      <Router />
      <ToastProvider />
    </ConfigProvider>
  </StrictMode>,
)
